import { Component } from '@angular/core';
import { TldreturnsService } from 'src/app/service/tldreturns.service';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false // NOSONAR
})
export class AppComponent {
  title = 'lios-tldreturns-mfe';

  isAuthorized: boolean = false;
	AUthToken: boolean = false;
	clientHeight: number;

  constructor(private readonly state: TldreturnsService) {
		console.info('Prod environment:' + environment.production)     // Logs false for all other environments
		this.clientHeight = window.innerHeight;
	}

  ngOnInit() { // NOSONAR
		if (localStorage.getItem('toyotaGUID')) {
			this.AUthToken = true;
		}

		
		this.state.roleState.subscribe((value) => {
			if (value) {
				this.isAuthorized = true;
			}
		});
	}

}
